import React from 'react';

// 44x24 track with a 20px thumb. Inline because left and colors are dynamic.
const SmsToggleSwitch = ({ checked, onToggle, disabled, style, labelledBy }) => {
    const handleClick = () => {
        if (!disabled) onToggle();
    };

    const handleKeyDown = (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            role="switch"
            aria-checked={!!checked}
            aria-disabled={disabled ? 'true' : undefined}
            aria-labelledby={labelledBy}
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            style={{
                width: '44px', height: '24px', borderRadius: '12px', cursor: disabled ? 'not-allowed' : 'pointer',
                backgroundColor: checked ? '#0f172a' : '#cbd5e1', position: 'relative', transition: 'background-color 0.2s', flexShrink: 0,
                ...style
            }}
        >
            <div style={{
                width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#fff', position: 'absolute', top: '2px',
                left: checked ? '22px' : '2px', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
            }} />
        </div>
    );
};

export default SmsToggleSwitch;
